import Typography from '@mui/material/Typography'

export default function SideNote({
  variant = 'body2',
  color = 'grey.400',
  children,
  ...props
}){
  return <Typography {...{variant, color, ...props}}>{children}</Typography>
}
